export * from './replace.directive';



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/directives/replace/index.ts